import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';

export const routes: Routes = [
    { path: 'home', component: HomeComponent },  // Strona główna na pustą ścieżkę
    { path: 'o-nas', component: AboutComponent }, // pełna strona "O nas"
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    // { path: 'o-nas', component: AboutComponent },  // Dodaj inne komponenty i trasy według potrzeby
    // { path: 'repertuar', component: RepertoireComponent }
];
